export default __webpack_public_path__ + "assets/models/a618dfa2e4b08014aef6e3fc7af8facb.glb";